import { inject } from '@angular/core';
import { MessageBridgeService } from './message-bridge';
import { SnowplowService } from './snowplow';
import { makeEvent } from '../analytics/builder';

export interface RegwallActions {
  onSignup(): void;
  onLogin(): void;
}

// Shared by RegwallInfo (V2) and V3RegwallInfo — identical signup/login click handlers.
export function regwallActions(): RegwallActions {
  const bridge = inject(MessageBridgeService);
  const snowplow = inject(SnowplowService);
  return {
    onSignup(): void {
      snowplow.track(
        makeEvent('element_clicked', { feature_name: 'button', element_title: 'register_button' }),
      );
      bridge.postMessage('REQUEST_REGISTER');
    },
    onLogin(): void {
      snowplow.track(
        makeEvent('element_clicked', { feature_name: 'button', element_title: 'login_button' }),
      );
      bridge.postMessage('REQUEST_LOGIN');
    },
  };
}
